import { useForm } from "@mantine/form";
import { validateRequired } from "../../../utils/validations";
import { Button, TagsInput, TextInput } from "@mantine/core";
import { Role } from "../../../types/types";
import { updateNotification } from "../../../utils/useNotification";
import { updateRoleById } from "../../../api/roleApi";
import CustomSelect from "../../common/Inputs/CustomSelect";

const RoleUpdateForm = ({
  role,
  closeModal,
  updateRoleList,
}: {
  role: Role;
  closeModal: any;
  updateRoleList: any;
}) => {
  const form = useForm<any>({
    initialValues: {
      name: role?.name,
      description: role?.description,
      requiredSkills: role?.requiredSkills,
    },
    validate: {
      name: validateRequired,
      description: validateRequired,
    },
  });

  const handleSubmit = async (values: object) => {
    try {
      const { data }: any = await updateRoleById({
        id: role?._id,
        updates: values,
      });
      if (data?.success) {
        updateNotification(data?.success);
        updateRoleList();
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      closeModal();
    }
  };

  return (
    <form
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "15px",
      }}
      onSubmit={form.onSubmit(handleSubmit)}
    >
      <TextInput
        label="Rol İsmi"
        placeholder="Rol İsmi Giriniz."
        radius={10}
        maxLength={40}
        size="md"
        {...form.getInputProps("name")}
      />
      <TextInput
        label="Rol Açıklaması"
        placeholder="Rol Açıklaması Giriniz."
        radius={10}
        maxLength={140}
        size="md"
        {...form.getInputProps("description")}
      />
      {/* buraya da requiredskills konulacak */}
      <CustomSelect
        label="Yetenekler"
        placeholder="Yetenek Seçiniz."
        clearable
        {...form.getInputProps("requiredSkills")}
      />

      <Button
        type="submit"
        color="#5C26FF"
        radius={10}
        disabled={!form.isDirty()}
      >
        Güncelle
      </Button>
    </form>
  );
};

export default RoleUpdateForm;
